import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { Deal } from "Types/api/Deal";

export const pollingSuccess = actionCreator(
    "POLLING_SUCCESS",
    (deal: Deal) => ({ deal }),
    () => ({})
);
